import shareRepository from "../repositories/ShareRepository";

class ShareService {
    constructor() {}

    async getById(id) {
        return shareRepository.getShare(id);
    }
}

export default new ShareService();
